var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightDecoration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 35,
  fill: "none",
  viewBox: "0 0 28 35"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F8C1B8",
  fillRule: "evenodd",
  d: "M.635 13.173c-.835-.912-.79-2.325.101-3.155L10.86.582c.89-.83 2.289-.764 3.123.148.835.913.79 2.326-.102 3.156L3.758 13.322c-.89.83-2.289.764-3.123-.149",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00664F",
  fillRule: "evenodd",
  d: "M2.422 15c-.835-.912-.79-2.325.102-3.156L12.646 2.41c.89-.83 2.289-.764 3.123.148.835.913.79 2.326-.101 3.156L5.545 15.149c-.89.83-2.289.764-3.123-.149",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8C1B8",
  fillRule: "evenodd",
  d: "M6.993 24.64c-.261-1.209.49-2.406 1.678-2.674l13.498-3.05c1.188-.268 2.362.495 2.623 1.703.26 1.21-.49 2.406-1.678 2.675L9.616 26.343c-1.188.268-2.362-.494-2.623-1.703",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00664F",
  fillRule: "evenodd",
  d: "M7.616 27.119c-.261-1.21.49-2.407 1.678-2.675l13.498-3.049c1.188-.268 2.362.494 2.623 1.703.26 1.209-.49 2.406-1.678 2.674l-13.498 3.05c-1.188.267-2.363-.495-2.623-1.703",
  clipRule: "evenodd"
})));
export default SvgRightDecoration;